import {
  InstantAnswerBuilderFn,
  InstantAnswerContext,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

export const TroubleshootingAndOtherPOSIA: InstantAnswerBuilderFn = (
  strictLocalize
) => ({
  titleBuilder: (context) => {
    return getAnswer(context, strictLocalize).getTitle();
  },

  descriptionBuilder: (context) => {
    return getAnswer(context, strictLocalize).getDescription();
  },
});

const getAnswer = (
  _context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () => COMMON_QUESTIONS_RELATED_TO_POS(strictLocalize),
    getDescription: () => [CHECK_OUT_COMMON_QUESTIONS(strictLocalize)],
  };
};

const COMMON_QUESTIONS_RELATED_TO_POS = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage: "Common questions related to POS",
    description: {
      text: "Title for the answer of Troubleshooting issue",
    },
  });

const CHECK_OUT_COMMON_QUESTIONS = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage:
      "Check out common questions related to POS integration at Faire in the linked article. If you have any further questions, please contact us.",
    description: {
      text: "Description for the answer of Troubleshooting issue. POS stands for Point of Sale.",
    },
  });
